import { gql } from '@apollo/client'

export const GET_ALL_TRUCKS = gql`
  query GetAllTrucks(
    $searchQuery: String
    $offset: Int
    $limit: Int
    $filters: FiltersTruck
  ) {
    getAllTrucks(
      searchQuery: $searchQuery
      offset: $offset
      limit: $limit
      filters: $filters
    ) {
      count
      rows {
        id
        plate_number
        type
        status
        capacity
        user_id
        TrucksToProviders {
          id
          card_name
        }
        TrucksToUsersDrivers {
          name
          first_name
          last_name
        }
      }
    }
  }
`

export const GET_TRUCK_BY_ID = gql`
  query GetTruckById($getTruckByIdId: Int!) {
    getTruckById(id: $getTruckByIdId) {
      data {
        id
        type
        status
        typeSpanish
        plate_number
        capacity
        user_id
        TrucksToUsersDrivers {
          id
          name
          first_name
          last_name
        }
      }
      message
      fieldsDisallowed
    }
  }
`

export const GET_TRUCKS_AVAILABLE = gql`
  query GetTrucksAvailables($capacity: Int) {
    getTrucksAvailables(capacity: $capacity) {
      id
      plate_number
      status
      type
      capacity
      TrucksToUsersDrivers {
        id
        name
        first_name
        last_name
      }
    }
  }
`

export const GET_STATUS_TRUCKS = gql`
  query GetStatusForTruck {
    getStatusForTruck {
      label
      value
    }
  }
`

export const GET_TYPE_TRUCKS = gql`
  query GetTypesForTruck {
    getTypesForTruck {
      label
      value
    }
  }
`

export const GET_CAPACITY_TRUCKS = gql`
  query GetCapacityForTruck {
    getCapacityForTruck {
      value
      label
    }
  }
`

export const CREATE_TRUCK = gql`
  mutation CreateTruck($truck: TruckInput!) {
    createTruck(truck: $truck)
  }
`

export const UPDATE_TRUCK = gql`
  mutation UpdateTruck($updateTruckId: Int!, $truck: TruckInput!) {
    updateTruck(id: $updateTruckId, truck: $truck)
  }
`

export const DELETE_TRUCK = gql`
  mutation DeleteTruck($id: Int!) {
    deleteTruck(id: $id)
  }
`
